import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { CartService } from '@hdms/shared/data-access';
import { URLS } from '@hdms/shared/page-frame/data-access';
import { HeaderMetaNavModule } from '@hdms/shared/page-frame/ui';
import { ButtonBaseClassesType, ButtonModule, IconsName, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule, CountIndicatorModule, LetModule } from '@hdms/shared/util-core';

@Component({
  standalone: true,
  selector: 'shrd-pf-ft-header-cart',
  templateUrl: './header-cart.component.html',
  styleUrls: ['./header-cart.component.scss'],
  imports: [
    AsyncPipe,
    ButtonModule,
    SvgIconModule,
    CountIndicatorModule,
    HeaderMetaNavModule,
    LetModule,
    AnalyticsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderCartComponent {
  readonly iconsName = IconsName;
  readonly cartUrl = URLS.cart;
  readonly cartAmount$ = inject(CartService).cartAmount$;

  @Input() btnVariant: ButtonBaseClassesType = 'tertiaryMinorBorderlessNeutralDark';
  @Input() btnClasses = '';
  @Input() title: string;
  @Input() trackingName?: string;
}
